"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _elementUi = require("element-ui");

var _bao = _interopRequireDefault(require("@/assets/bao.jpg"));

var _vuex = require("vuex");

var _utils = require("@/utils");

var _tool = require("@/utils/tool");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Breadcrumb from '@/components/Breadcrumb'
// import Hamburger from '@/components/Hamburger'
var _default = {
  components: {// Breadcrumb,
    // Hamburger
  },
  data: function data() {
    return {
      logo: _bao.default,
      loginData: {},
      dialogReset: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['sidebar', 'avatar', 'name', 'developer_uid', 'isVip'])),
  created: function created() {
    this.$store.dispatch('user/getInfo');
    var data = localStorage.getItem((0, _utils.getStorageKey)('userInfo'));

    var _JSON$parse = JSON.parse(data),
        loginData = Object.assign({}, _JSON$parse);

    this.loginData = loginData;
  },
  methods: {
    getUrl: _tool.getUrl,
    goHome: function goHome() {
      this.$router.push({
        path: '/'
      });
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _elementUi.MessageBox.confirm('您确定退出当前账号吗？', '退出', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this.$store.dispatch('user/logout');

                        case 2:
                          _this.$router.push("/login");

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))).catch(function () {
                  _this.$message({
                    type: 'info',
                    message: '取消退出，继续使用~'
                  });
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 重置密码
    resetPassword: function resetPassword() {
      this.dialogReset = true;
    }
  }
};
exports.default = _default;